const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5056/api').replace(/\/$/, '');

async function request(path, { method = 'GET', body, token, query } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  const qs = query
    ? '?' + Object.entries(query)
        .filter(([_, v]) => v !== undefined && v !== '')
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&')
    : '';
  const res = await fetch(`${API_BASE}${path}${qs}`, {
    method, headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data?.error?.message || `HTTP ${res.status}`);
    err.code   = data?.error?.code || `HTTP_${res.status}`;
    err.status = res.status;
    throw err;
  }
  return data;
}

export const seancesApi = {
  list:        (opts)         => request('/seances',                   { query: opts }),
  get:         (id)           => request(`/seances/${id}`),
  adminList:   (token, opts)  => request('/admin/seances',             { token, query: opts }),
  adminGet:    (token, id)    => request(`/admin/seances/${id}`,       { token }),
  adminCreate: (token, body)  => request('/admin/seances',             { method: 'POST',   token, body }),
  adminUpdate: (token, id, b) => request(`/admin/seances/${id}`,       { method: 'PATCH',  token, body: b }),
  adminDelete: (token, id)    => request(`/admin/seances/${id}`,       { method: 'DELETE', token }),
};

export const SEANCE_TYPES = [
  { id: 'all',            lbl: 'Tous types' },
  { id: 'ordinaire',      lbl: 'Ordinaire' },
  { id: 'extraordinaire', lbl: 'Extraordinaire' },
  { id: 'bureau',         lbl: 'Bureau' },
];

export const SEANCE_STATUSES = [
  { id: 'all',       lbl: 'Tous statuts' },
  { id: 'annoncee',  lbl: 'Annoncée' },
  { id: 'tenue',     lbl: 'Tenue' },
  { id: 'publiee',   lbl: 'Publiée' },
];

export const VOTE_OPTIONS = [
  { id: 'adopte',     lbl: 'Adoptée' },
  { id: 'rejete',     lbl: 'Rejetée' },
  { id: 'reporte',    lbl: 'Reportée' },
  { id: 'sans_objet', lbl: 'Sans objet' },
];

export const TYPE_LABEL   = Object.fromEntries(SEANCE_TYPES.map((t)   => [t.id, t.lbl]));
export const STATUS_LABEL = Object.fromEntries(SEANCE_STATUSES.map((s) => [s.id, s.lbl]));
export const VOTE_LABEL   = Object.fromEntries(VOTE_OPTIONS.map((v)    => [v.id, v.lbl]));
